import React from 'react';
import { Card, Typography, Button, Space } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import PhenoAgeValidation from '../components/PhenoAgeValidation';

const { Title, Paragraph } = Typography;

const PhenoAgeValidationPage = () => {
  const navigate = useNavigate();

  return (
    <div style={{ padding: '24px', maxWidth: '1400px', margin: '0 auto' }}>
      <Space direction="vertical" size="large" style={{ width: '100%' }}>
        <Card>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '16px' }}>
            <div>
              <Title level={1} style={{ margin: 0, color: '#1890ff' }}>
                🧬 PhenoAge Mathematical Validation Suite
              </Title>
              <Paragraph style={{ margin: '8px 0 0 0', fontSize: '16px', color: '#666' }}>
                Comprehensive validation and sensitivity analysis of the Care360 PhenoAge biological age calculation
              </Paragraph>
            </div>
            <Button 
              icon={<ArrowLeftOutlined />} 
              onClick={() => navigate('/dashboard')}
              size="large"
            >
              Back to Dashboard
            </Button>
          </div>
          
          <div style={{ 
            padding: '16px', 
            backgroundColor: '#f0f8ff', 
            borderRadius: '8px', 
            border: '1px solid #d6e4ff',
            marginBottom: '24px'
          }}>
            <Title level={4} style={{ color: '#1890ff', margin: '0 0 8px 0' }}>
              🎯 Validation Objectives
            </Title>
            <ul style={{ margin: 0, paddingLeft: '20px' }}>
              <li><strong>Mathematical Verification:</strong> Cross-reference against Excel reference (PhenoAge: 60.24 years, Age Diff: -11.94 years)</li>
              <li><strong>Sensitivity Analysis:</strong> Quantify parameter impact with ±1%, ±5%, ±10% perturbations</li>
              <li><strong>Boundary Conditions:</strong> Test extreme clinical values and mathematical stability</li>
              <li><strong>Numerical Precision:</strong> Assess floating-point accuracy and error propagation</li>
              <li><strong>Clinical Validation:</strong> Verify robustness for clinical implementation</li>
            </ul>
          </div>
        </Card>

        <PhenoAgeValidation />
      </Space>
    </div>
  );
};

export default PhenoAgeValidationPage;
